module.exports = __webpack_public_path__ + "static/media/22.cb525b12.png";